import React from "react";
import { FormControl, InputLabel, NativeSelect, FormControlLabel, Checkbox } from "@mui/material";
import { Category } from "../types/productTypes";
import { BootstrapInput } from "../EditProduct/components/styles";
import CommonButtons from "src/shared/components/CommonButtons";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { ToastContainer } from "react-toastify";

/* ---------- Props ---------- */
interface ProductToolbarProps {
  categories: Category[];
  categoryFilter: string;
  onCategoryChange: (value: string) => void;

  showDeletedProducts: boolean;
  onToggleDeleted: () => void;

  searchTerm: string;
  onSearchChange: (value: string) => void;

  onAddProduct: () => void;
}

/* ---------- Component ---------- */
const ProductToolbar: React.FC<ProductToolbarProps> = ({ categories, categoryFilter, onCategoryChange, showDeletedProducts, onToggleDeleted, searchTerm, onSearchChange, onAddProduct }) => {
  const { fontClass, borderHighlight } = useUserTheme();
  return (
    <div className="product-add-container">
      <div className="product-toolbar">
        {/* Category Filter */}
        <FormControl variant="standard">
          <InputLabel htmlFor="category-select">
            Search by category&nbsp;
            <span className="text-[#f04141] text-[15px]">*</span>
          </InputLabel>
          <NativeSelect sx={{ width: "300px" }} value={categoryFilter} onChange={(e) => onCategoryChange(e.target.value)} input={<BootstrapInput />}>
            <option value="all">All Categories</option>
            {categories.map((cat) => (
              <option key={cat._id.$oid} value={cat._id.$oid}>
                {cat.CategoryName}
              </option>
            ))}
          </NativeSelect>
        </FormControl>

        {/* Deleted Toggle */}
        <FormControlLabel control={<Checkbox checked={showDeletedProducts} onChange={onToggleDeleted} />} label="View deleted products" />

          <div className="w-full max-w-[350px]">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search by Product name"
            className={`w-full px-3 py-2.5 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
          />
          {/* {searchTerm && (
            <IconButton
              size="small"
              onClick={() => onSearchChange("")}
              className="absolute right-1 top-1/2 -translate-y-1/2"
            >
              <Close fontSize="small" />
            </IconButton>
          )} */}
        </div>
        <div className="flex items-center" id="add-customer-btn">
          <CommonButtons className="w-44 h-10" label="ADD PRODUCT" onClick={onAddProduct} />
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover />
    </div>
  );
};

export default ProductToolbar;
